const internalEmailDomain = '@griply.app';

export const isInternalUser = (email?: string | null): boolean =>
  !!email?.endsWith(internalEmailDomain);
